import { render } from "./ViewImage.vue?vue&type=template&id=36639516&scoped=true"
import script from "./ViewImage.vue?vue&type=script&lang=js"
export * from "./ViewImage.vue?vue&type=script&lang=js"

import "./ViewImage.vue?vue&type=style&index=0&id=36639516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36639516"]])

export default __exports__